import { Outlet } from "react-router";

export default function EmptyLayout() {
    return <Outlet />;
}
